import { use } from 'react'

const messages = {
  menu: 'Menú',
  close_menu: 'Cerrar menú',
  navigation: 'Navegación',
  account: 'Cuenta',
  logout: 'Cerrar sesión',
  calendar: 'Calendario',
  recipes: 'Recetas',
  products: 'Productos',
  general_content: 'General',
  cancel: 'Cancelar',
  ok: 'Aceptar',
  steps: 'Pasos',
  ingredients: 'Ingredientes',
  others: 'Otros',
  delete: 'Borrar',
  name: 'Nombre',
  type: 'Tipo',
  time: 'Tiempo',
  breakfast: 'Desayuno',
  almuerzo: 'Almuerzo',
  lunch: 'Comida',
  merienda: 'Merienda',
  dinner: 'Cena',
  add: 'Añadir',
  filter_by: 'Filtrar por',
  options: 'Opciones',
  tuppers_generated: 'Tuppers Generados',
  tuppers: 'Tuppers',
  question_mark: '?',
  x_mark: 'X',
  shop: 'Tienda',
  quantity: 'Cantidad',
  recipe: 'Receta',
  recipe_name: 'Nombre de la receta',
  recipe_type: 'Tipo de la receta',
  recipe_time: 'Tiempo de la receta',
  recipe_exists: 'Ya existe una receta con ese nombre',
  recipe_name_empty: 'El nombre de la receta no puede estar vacío',
  recipe_time_empty: 'Selecciona al menos una comida',
  recipe_save_error: 'Error al guardar la receta: ',
  recipe_delete_confirm: '¿Estás seguro de que quieres borrar esta receta?',
  recipe_delete_error: 'Error al borrar la receta: ',
  recipe_ingredient_empty:
    'Los ingredientes de la receta no pueden estar vacíos',
  recipe_ingredient_qty_invalid:
    'La cantidad de los ingredientes debe ser mayor que 0',
  recipe_ingredient_duplicated: 'No puede haber ingredientes duplicados',
  recipe_step_num_duplicated: 'No puede haber pasos con el mismo número',
  recipe_step_empty: 'Los pasos de la receta no pueden estar vacíos',
  recipe_step_title: 'Paso %1',
  recipe_new: 'Nueva receta',
  recipe_select: 'Selecciona una receta...',
  recipe_cook: 'Cocinar',
  recipe_complete_confirm:
    'Se completará la receta generando %1 tuppers. ¿Quieres continuar?',
  recipe_link_empty: 'Los enlaces no pueden estar vacíos',
  recipe_duplicate_confirm: 'Se duplicará la receta. ¿Quieres continuar?',
  recipe_duplicate_error: 'Error al duplicar la receta: ',
  recipe_alert: 'Alerta',
  recipe_alert_type: 'Tipo de alerta',
  recipe_same_day_morning: 'Mismo día por la mañana',
  recipe_previous_day_morning: 'Día anterior por la mañana',
  recipe_previous_day_night: 'Día anterior por la noche',
  duplicate: 'Duplicar',
  product: 'Producto',
  product_name: 'Nombre del producto',
  product_shop: 'Tienda del producto',
  product_ingredient_tick: 'Ingrediente',
  product_storable_tick: 'Almacenable',
  product_pack: 'Pack de ',
  product_ingredient_filter: 'Solo ingredientes',
  product_storable_filter: 'Solo almacenables',
  product_packable_filter: 'Solo en pack',
  product_new: 'Nuevo producto',
  product_exists: 'Ya existe un producto con ese nombre',
  product_name_empty: 'El nombre del producto no puede estar vacío',
  product_shop_empty: 'La tienda del producto no puede estar vacía',
  product_pack_invalid: 'El pack del producto debe ser al menos 1',
  product_save_error: 'Error al guardar el producto: ',
  product_delete_confirm: '¿Estás seguro de que quieres borrar este producto?',
  product_delete_error: 'Error al borrar el producto: ',
  product_select: 'Selecciona un producto...',
  product_not_selected: 'Por favor, selecciona un producto',
  product_qty_error: 'La cantidad del producto debe ser mayor que 0',
  ingredient_select: 'Selecciona un ingrediente...',
  storage: 'Despensa',
  storage_product_exists: 'El producto ya está en la despensa',
  save_error: 'Error al guardar: ',
  tupper_new: 'Nuevo tupper',
  item_not_selected: 'Por favor, selecciona un artículo',
  storage_tupper_exists: 'El tupper ya está en la despensa',
  shopping_list: 'Compra',
  complete: 'Completar',
  shopping_list_new_product:
    'El producto no existe ¿quieres crearlo con los valores por defecto?',
  no_ingredients: 'No hay ingredientes',
  links: 'Enlaces',
  error_insert_meal: 'Error al insertar la comida',
  templates: 'Plantillas',
  template_default: 'Plantilla por defecto',
  template_set_default: 'Por defecto',
  template_edit: 'Editar',
  template_new: 'Nueva plantilla',
  template_name: 'Nombre de la plantilla',
  save_changes: 'Guardar cambios',
  template_save_error: 'Error al guardar la plantilla: ',
  template_load_error: 'Error al cargar la plantilla',
  template_recipes_load_error: 'Error al cargar las recetas',
  for: 'para',
  no_week_info: 'No hay información de la semana',
  create_week_confirm: 'No hay información para esta semana. ¿Quieres crearla?',
  loading: 'Cargando...',
  recipe_comes_from_tupper_alert: 'Recuerda sacar el tupper',
  user: 'Usuario',
  users: 'Usuarios',
  user_alerts_only: 'Solo con Alertas',
  user_alerts_active: 'Con Alertas',
  user_admin_only: 'Solo Administradores',
  user_alerts: 'Alertas',
  user_admin: 'Administrador',
  user_new: 'Nuevo usuario',
  user_name: 'Nombre de usuario',
  user_chat_id: 'ID de chat de Telegram (alertas)',
  user_save_error: 'Error al guardar el usuario: ',
  user_name_empty: 'El nombre de usuario no puede estar vacío',
  user_password_empty: 'La contraseña no puede estar vacía',
  user_password: 'Nueva Contraseña',
  user_name_exists: 'Ya existe un usuario con ese nombre',
  user_delete_confirm: '¿Estás seguro de que quieres borrar este usuario?',
  user_delete_error: 'Error al borrar el usuario: ',
  user_config_title: 'Configuración de Usuario',
}

function getMessage(key: keyof typeof messages, parameters?: string[]) {
  let msg = messages[key]

  if (parameters) {
    parameters.forEach((param, index) => {
      msg = msg.replace(`%${index + 1}`, param)
    })
  }

  return msg
}
export { getMessage }
